import { MinuteNumber, DayHour, DayNumber, MonthNumber, WeekDayNumber } from '../../time/constants'
import { CronStringLikeMap, CronStringLikeValue } from '../../../types'
import {} from '..'

export const CronLikeToString = (cronOb: CronStringLikeMap): string => {
  let cronString: string = `${cronOb.minute.join(',')} ${cronOb.hour.join(',')} ${cronOb.dayOfMonth.join(',')} ${cronOb.month.join(',')} ${cronOb.dayOfWeek.join(',')}`

  return cronString
}

const mapper = (x: string): string | number => {
  const nan = isNaN(parseInt(x))

  return nan ? x : parseInt(x)
}

export const cronStringToLikeMap = (cronString: string): CronStringLikeMap => {
  const arr = cronString.split(' ')
  const map: CronStringLikeMap = {
    minute: arr[0].split(',').map(mapper) as unknown as CronStringLikeValue<MinuteNumber>,
    hour: arr[1].split(',').map(mapper) as unknown as CronStringLikeValue<DayHour>,
    dayOfMonth: arr[2].split(',').map(mapper) as unknown as CronStringLikeValue<DayNumber>,
    month: arr[3].split(',').map(mapper) as unknown as CronStringLikeValue<MonthNumber>,
    dayOfWeek: arr[4].split(',').map(mapper) as unknown as CronStringLikeValue<WeekDayNumber>,
  }

  return map
}
